angular.module('unergie.main')
.controller('readingsGasCtrl', ($scope, $state, MetaWatcher, DownloadService, DataAccess, DataAccessSearch, AuthService, BoFeaturesService,
    TableGeneratorService, XmlParser, AlertManager, ErrorCatcher) => {
    const MAX_SELECTIONS = 20

    $scope.isPlum = AuthService.getAuth().organization === 'plum'
    // $scope.adminMode = BoFeaturesService.getModuleFeatures('readings-gas').adminMode
    $scope.adminMode = true
    $scope.readings = {
        refreshing: false,
        columns: {
            selector: $scope.adminMode ? { label: 'Selection', mode: 'filter_only' } : undefined,
            id: { label: 'ID', mode: $scope.adminMode ? 'search_operator' : 'hidden' },
            id_pce: { label: 'PCE', mode: 'search_wildcard' },
            start_date: { label: 'Début', mode: 'search_date' },
            end_date: { label: 'Fin', mode: 'search_date' },
            motivation: { label: 'Motivation', mode: 'search_wildcard' },
            status: { label: 'Statut', mode: $scope.adminMode ? 'search_wildcard' : 'hidden' },
            face_digits: { label: 'Nb digits', mode: 'hidden' },
            serial: { label: 'Matricule', mode: $scope.adminMode ? 'search_wildcard' : 'hidden' },
            raw_end_index: { label: 'Valeur', mode: 'search_operator' },
            raw_start_index: { label: 'Valeur Préc.', mode: $scope.adminMode ? 'search_operator' : 'hidden' },
            distributor_status: { label: 'Distributeur', mode: 'search_wildcard' },
            source: { label: 'Source', mode: 'hidden' },
            raw_volume: { label: 'Conso', mode: $scope.adminMode ? 'search_operator' : 'hidden' },
            invoice_status: { label: 'Facturation', mode: $scope.adminMode ? 'search_wildcard' : 'hidden' },
        },
    }

    $scope.clonePayload = {}

    $scope.changeStatusPayload = {
        distributor_status: '',
    }

    $scope.changeStatusFields = {
        distributor_status: {
            label: 'Status',
            required: true,
            type: 'select',
            enum: [
                { label: 'ERROR', value: 'ERROR' },
                { label: 'CORRECTED', value: 'CORRECTED' },
                { label: 'OK', value: 'OK' },
                { label: 'REMOVED', value: 'REMOVED' },
                { label: 'IGNORED', value: 'IGNORED' },
            ],
        },
    }

    $scope.canDuplicate = () => {
        return _.every($scope.readings.instance.data, (r) => !r.duplicating)
    }

    $scope.prepareDuplicate = (reading) => {
        if (!$scope.canDuplicate()) {
            return
        }
        reading.duplicating = true
        _.assign($scope.clonePayload, reading)
        $scope.clonePayload.start_date = $scope.clonePayload.start_date && moment($scope.clonePayload.start_date).toDate()
        $scope.clonePayload.end_date = $scope.clonePayload.end_date && moment($scope.clonePayload.end_date).toDate()
        delete $scope.clonePayload.raw_volume
    }

    $scope.clone = (reading, mode) => {
        const payload = _.pick($scope.clonePayload, [
            'start_date',
            'end_date',
            'motivation',
            'status',
            'face_digits',
            'serial',
            'raw_end_index',
            'raw_start_index',
            'distributor_status',
            'source',
            'raw_volume',
            'invoice_status',
        ])
        if (payload.raw_start_index === null) {
            delete payload.raw_start_index
        }
        if (payload.raw_volume === null) {
            delete payload.raw_volume
        }
        if (payload.start_date) {
            payload.start_date = moment(payload.start_date).toISOString()
        } else {
            delete payload.start_date
        }
        payload.end_date = moment(payload.end_date).toISOString()
        reading[`${mode}ing`] = true
        return DataAccess.cloneGasReading({ id: reading.id, mode }, payload).$promise.then((result) => {
            AlertManager.success('Modifié')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            reading[`${mode}ing`] = false
        })
    }

    $scope.revertCorrection = (reading) => {
        reading.cancelling = true
        return DataAccess.revertGasReadingCorrection({ id: reading.id }).$promise.then((result) => {
            AlertManager.success('Suppression OK')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            reading.cancelling = false
        })
    }

    $scope.modifyStatus = (reading) => {
        reading.modifying = true
        return DataAccess.updateGasReading({ id: reading.id }, $scope.changeStatusPayload).$promise.then((result) => {
            AlertManager.success('Modifié')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            reading.modifying = false
        })
    }

    $scope.modifySelectedStatus = () => {
        const updates = $scope.getSelected().map((reading) => {
            reading.modifying = true
            return {
                id: reading.id,
                distributor_status: $scope.changeStatusPayload.distributor_status,
            }
        })
        return DataAccess.updateGasReadingBatch({}, updates).$promise.then((result) => {
            AlertManager.addAlert({
                type: 'success',
                msg: `Modifications de statut en ${$scope.changeStatusPayload.distributor_status} ok`,
                detail: _.map(result, JSON.stringify),
                hideDetails: true,
            })
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.getSelected().forEach((reading) => {
                reading.modifying = false
            })
        })
    }

    $scope.canDl = (reading) => reading.source && reading.source.startsWith('s3://')

    $scope.dl = (reading) => DownloadService.s3Download(reading.source)

    $scope.checkStart = (reading) => {
        return !!_.find($scope.readings.instance.data, (r) => {
            return r.id !== reading.id && r.distributor_status === 'OK' && r.id_pce === reading.id_pce && r.temp_class === reading.temp_class && r.class === reading.class &&
                r.end_date === reading.start_date
        })
    }

    $scope.checkEnd = (reading) => {
        return !!_.find($scope.readings.instance.data, (r) => {
            return r.id !== reading.id && r.distributor_status === 'OK' && r.id_pce === reading.id_pce && r.temp_class === reading.temp_class && r.class === reading.class &&
                r.start_date === reading.end_date
        })
    }

    $scope.getSelected = () => {
        if (!$scope.readings.instance) {
            return []
        }
        return $scope.readings.instance.data.filter((r) => r.selected)
    }


    $scope.toggleSelected = (reading) => {
        // if selecting, verify not exceeding max selections authorized
        if (!reading.selected && ($scope.getSelected().length >= MAX_SELECTIONS)) {
            AlertManager.error(`Vous ne pouvez pas sélectionner plus de ${MAX_SELECTIONS} éléments`)
        } else {
            reading.selected = !reading.selected
        }
    }


    $scope.isSelectable = (reading) => !reading.invoicing_status || (reading.invoicing_status === 'CHECKED')

    const transformData = (data) => {
        let alternate = false

        return data.forEach((reading, i) => {
            const previous = data[i - 1]
            reading.start_date_SOD = reading.start_date && moment(reading.start_date).startOf('day').toISOString()
            reading.end_date_SOD = reading.end_date && moment(reading.end_date).startOf('day').toISOString()

            if (!previous || previous.id_pce !== reading.id_pce || previous.start_date_SOD !== reading.start_date_SOD || previous.end_date_SOD !== reading.end_date_SOD) {
                alternate = !alternate
            }

            reading.alternate = alternate
        })
    }

    $scope.refresh = () => {
        TableGeneratorService.getTable($scope.readings, 'readings-gas', null, transformData, { orderBy: '-end_date,-start_date,id_pce' })
    }

    const activate = () => {
        $scope.refresh()
        MetaWatcher.watch('TABLE_READINGS_GAS_DATA_CHANGED', 'readings-gas', $scope, () => {
            if ($scope.readings.instance) {
                $scope.readings.instance.data.forEach((r) => {
                    r.selected = false
                })
            }
        })
    }

    activate()
})
